<template>
	<div :class="[{ 'show-mobile-nav': showMobileNav, 'lightbox-open': lightboxOpen }, 'page']">
		<header class="app-header">
			<div class="contain flex">
				<Logo @click.native="showMobileNav = false" />

				<template v-if="$activeUser">
					<nav class="main-nav flex gap-24 show-bp-nav">
						<router-link :to="{ name: $routes.Profile.name }">Profile</router-link>
						<router-link v-if="showJobsNavItem" :to="{ name: $routes.Jobs.name }">Jobs</router-link>
						<button class="reset rel">
							<router-link :to="{ name: $routes.Favorites.name }" class="flex gap-4">
								Favorites
								<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path opacity="0.6" d="M9.5 4.5L5.75 8.25L2 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</router-link>
							<div class="droplist droplist-hover" style="width:204px;">
								<router-link :to="{ name: $routes.Favorites.name }" class="droplist-item">Favorites</router-link>
								<router-link :to="{ name:  $routes.BrowseTalent.name }" class="droplist-item">Browse Talent</router-link>
							</div>
						</button>
						<router-link :to="{ name: $routes.Messages.name }">Messages</router-link>
					</nav>

					<div class="masthead-utility flex-right grow align-right gap-8 lg-gap-12">
						<a v-if="showGetCertified" href="https://certifications.shootwith.me" target="_blank" class="btn show-sm">
							Get Certified
						</a>
						<router-link v-else :to="{ name: $routes.FindHelpDetails.name }" class="btn show-sm">
							<span class="fs-14 icon-text">Hire Help</span>
						</router-link>

						<!-- Messages -->
						<button :class="{ 'is-open': showMessagesDroplist, 'has-unread': hasUnreadMessages }" class="toggle-droplist btn-util util-messages" @click.self="showMessagesDroplist = !showMessagesDroplist">
							<icon-chat />
							<Droplist :toggle="showMessagesDroplist" class="chat-droplist" @close="showMessagesDroplist = false">
								<ChatDroplist />
							</Droplist>
						</button>

						<!-- Notifications -->
						<button :class="{ 'is-open': showNotificationsDroplist, 'has-unread': hasUnreadNotifications }" class="toggle-droplist btn-util util-notifications" @click.self="showNotificationsDroplist = !showNotificationsDroplist">
							<icon-bell-new />
							<Droplist :toggle="showNotificationsDroplist" class="droplist-notifications" @close="showNotificationsDroplist = false">
								<NotificationDroplist />
							</Droplist>
						</button>

						<div class="nav-toggle" @click="showMobileNav = !showMobileNav">
							<div></div>
							<div></div>
							<div></div>
							<div></div>
						</div>
					</div>

					<!-- Account -->
					<button class="toggle-droplist ml-24 flex util-account show-bp-nav" @click.self="showAccountDroplist = !showAccountDroplist">
						<ProfileAvatar :profile="$activeProfile" size="40" class="square-40" />
						<div class="fs-14 color-violet ml-8 mr-12 fw-400">{{ $activeUser.firstName }} {{ $activeUser.lastName.substr(0,1) }}.</div>
						<icon-carat-left class="carat" />
						<Droplist :toggle="showAccountDroplist" class="account-droplist" @close="showAccountDroplist = false" style="width:206px">
							<router-link :to="{ name: $routes.Profile.name }" class="droplist-item">Profile</router-link>
							<router-link :to="{ name: $routes.Favorites.name }" class="droplist-item">Favorites &amp; Blocklist</router-link>
							<router-link :to="{ name:  $routes.AccountInfo.name }" class="droplist-item">Account</router-link>
							<!-- <div class="droplist-item" @click="showAccountDroplist = false">Refer a Friend &amp; Earn $$$</div> -->
							<div class="droplist-item" v-if="isStudio" @click="upgrade">Get Hired!</div>
							<div class="droplist-item" @click="$logout">Log Out</div>
						</Droplist>
					</button>
				</template>
				<template v-else>
					<div class="align-right flex-right pl-16 gap-16 wrap">
						<router-link :to="{ name: $routes.Login.name  }" class="btn">
							Log In
						</router-link>
						<router-link :to="{ name: $routes.Onboarding.name  }" class="btn btn-green">
							Join ShootWith.Me
						</router-link>
					</div>
				</template>
			</div>
		</header>

		<div v-if="$activeUser && showMobileNav" class="mobile-nav">
			<nav class="main-nav">
				<router-link :to="{ name: $routes.Profile.name }" @click.native="showMobileNav = false">Profile</router-link>
				<router-link v-if="showJobsNavItem" :to="{ name: $routes.Jobs.name }" @click.native="showMobileNav = false">Jobs</router-link>
				<router-link :to="{ name: $routes.Favorites.name }" @click.native="showMobileNav = false">Favorites</router-link>
				<router-link :to="{ name: $routes.BrowseTalent.name }" @click.native="showMobileNav = false">Browse Talent</router-link>
				<router-link :to="{ name: $routes.Messages.name  }" @click.native="showMobileNav = false">Messages</router-link>
			</nav>
			<div class="mt-32 flex gap-16 pb-32 border-bottom-07">
				<a v-if="showGetCertified" href="https://certifications.shootwith.me" target="_blank" class="btn">
					Get Certified
				</a>
				<router-link v-else :to="{ name: $routes.FindHelpDetails.name }" @click.native="showMobileNav = false" class="btn">
					<span class="fs-14 icon-text">Hire Help</span>
				</router-link>
			</div>
			<div class="mt-32 mb-24 flex">
				<ProfileAvatar :profile="$activeProfile" size="50" class="square-50" />
				<div class="ml-16 fw-700 fs-18 lh-20 color-violet">{{ $activeUser.firstName }} {{ $activeUser.lastName }}</div>
			</div>
			<nav class="flex-col flex-top gap-16">
				<router-link :to="{ name: $routes.Profile.name }" @click.native="showMobileNav = false" class="color-violet fs-16 lh-19 fw-400">Profile</router-link>
				<router-link :to="{ name: $routes.Favorites.name }" @click.native="showMobileNav = false" class="color-violet fs-16 lh-19 fw-400">Favorites &amp; Blocklist</router-link>
				<router-link :to="{ name: $routes.AccountInfo.name }" @click.native="showMobileNav = false" class="color-violet fs-16 lh-19 fw-400">Account</router-link>
				<!-- <button class="reset color-violet fs-16 lh-19 fw-400 text-left" @click="showMobileNav = false">Refer a Friend &amp; Earn $$$</button> -->
				<button class="reset color-violet fs-16 lh-19 fw-400 text-left" @click="upgrade" v-if="isStudio">Get Hired!</button>
				<button class="reset color-violet fs-16 lh-19 fw-400 text-left" @click="$logout">Log Out</button>
			</nav>
		</div>

		<router-view />

		<!-- Portfolio upload progress widget -->
		<PortfolioUploadProgress />

		<!-- Share profile modal -->
		<ShareProfileModal />

		<!-- Sync calendar modal -->
		<SyncCalendar />

		<!-- Upgrade modal for Talent accounts -->
		<SubscriptionFormModal v-if="isTalent" v-model="showUpgradeModal" @save="onSaveSubscription">
			<template #plan-title>{{ upgradeHeading }}</template>
			<template #plan>
				<p>{{ upgradePrompt }}</p>
			</template>
		</SubscriptionFormModal>
		<!-- Upgrade modal for Studio accounts -->
		<Modal v-else v-model="showUpgradeModal" class="center" no-close-button>
			<template #title>{{ upgradeHeading }}</template>
			<template #content>
				<p>{{ upgradePrompt }}</p>
				<p>
					<UpgradeButton class="button-green">{{ upgradeAcceptButtonText }}</UpgradeButton>
				</p>
				<p>
					<BaseButton class="button-inline" @click="showUpgradeModal = false">
						{{ upgradeDeclineButtonText }}
					</BaseButton>
				</p>
			</template>
		</Modal>
	</div>
</template>

<script>
import layout from '@/mixins/layout';
import helpers from '@/mixins/helpers';
import { request } from '@/plugins/axios';

import SyncCalendar from '@/components/calendars/SyncCalendar';
import NotificationDroplist from '@/components/notifications/NotificationDroplist';
import ChatDroplist from '@/components/chats/ChatDroplist';
import SubscriptionFormModal from '@/components/forms/SubscriptionFormModal';
import { fetchUserMetrics, fetchLastInvoice } from '@/services/swm/api';

export default {
  name: 'AppLayout',
  mixins: [layout, helpers],
  components: { ChatDroplist, NotificationDroplist, SubscriptionFormModal, SyncCalendar },
  data() {
    return {
      /** @type {boolean} */
      isNavigatingToOnboarding: false,
      /** @type {boolean} */
      showMenu: false,
      /** @type {boolean} */
      showMessages: false,
      /** @type {boolean} */
      showCreateDroplist: false,
      showNotificationsDroplist: false,
      showMessagesDroplist: false,
      showAccountDroplist: false,
      showMobileNav: false,
      earnedCertifications: [],
    };
  },
  computed: {
    hasUnreadMessages() {
      return this.$store.getters['chats/getUnreadCount'] > 0;
    },
    lightboxOpen() {
      return this.$store.getters['global/lightboxOpen'];
    },
    hasUnreadNotifications() {
      /** @type {readonly AppNotification[] | null} */
      const notifications = this.$store.getters['notifications/currentNotifications'];
      if (!notifications) {
        return false;
      }
      return notifications.some((notif) => notif.isUnread);
    },
    isStudio() {
      const level = this.subscriptionLevel;
      return !!level && !level.canBeHired;
    },
    isTalent() {
      return !!this.subscriptionLevel?.canBeHired;
    },
    rootClass() {
      return 'app';
    },
    showUpgradeModal: {
      /**
       * @returns {boolean}
       */
      get() {
        return !!this.$store.getters['subscriptions/showUpgradeModal'];
      },
      /**
       * @param {boolean} value
       */
      set(value) {
        this.$store.commit('subscriptions/setShowUpgradeModal', value);
      },
    },
    subscription() {
      return this.$store.getters['subscriptions/current'];
    },
    subscriptionLevel() {
      return this.$store.getters['subscriptions/currentLevel'];
    },
    upgradeAcceptButtonText() {
      return this.isStudio ? 'Add a Shooter Role' : 'Upgrade Now';
    },
    upgradeDeclineButtonText() {
      return `Nevermind, I don’t want to ${this.isStudio ? 'be a shooter' : 'upgrade'}.`;
    },
    upgradeHeading() {
      // TODO: update route names?
      const route = this.upgradeRoute;
      if (route && typeof route === 'object' && route.name == 'availability') {
		return 'Set Your Availability';
      }
	
      return this.isStudio ? 'Get Hired' : 'Upgrade Your Account';
    },
    upgradePrompt() {
      const { isStudio } = this;
      let upgradeYourAccount = `${isStudio ? 'add a shooter role to' : 'upgrade'} your account`;
      let useThisFeature = isStudio ? 'get hired by another studio' : 'use this feature';
      switch (this.upgradeRoute?.name) {
        case 'availability':
          useThisFeature = 'set your availability';
          break;
        default:
          if (isStudio) {
            upgradeYourAccount += ' and set your availability';
          }
          break;
      }
      let prompt = `To ${useThisFeature}, you’ll need to ${upgradeYourAccount}.`;
      if (isStudio) {
        prompt += ' Don’t worry, you’ll still be able to hire talent as a studio as well.';
      }
      return prompt;
    },
    upgradeRoute: {
      get() {
        return this.$store.getters['onboarding/postOnboardingRoute'];
      },
      set(route) {
        return this.$store.commit('onboarding/setPostOnboardingRoute', route);
      },
    },
	showGetCertified() {
		const earnedLead = this.earnedCertifications.filter(obj => obj.keyword == 'LeadShooterCertified');
		const earnedSecond = this.earnedCertifications.filter(obj => obj.keyword == 'LeadShooterCertified');
		const earnedAssistant = this.earnedCertifications.filter(obj => obj.keyword == 'AssistantCertified');
		
		if (this.myRoleId == 2 && !earnedAssistant.length) {
			return true;
		}

		if (this.myRoleId == 3 && !earnedSecond.length) {
			return true;
		}
		
		if (this.myRoleId == 4 && !earnedLead.length) {
			return true;
		}

		return false; // todo
	},
	showJobsNavItem() {
		if (this.$activeUser && this.$activeUser.hasCreatedOrRecievedJob) {
			return true;
		}

		return false;
	},
  },
  methods: {
	formatInvoice(number) {
		const numberString = String(number);
		return Number(numberString.slice(0, numberString.length - 2) + '.' + numberString.slice(numberString.length - 2));
	},
	async initPendo() {
		const visitorData = {
			id: this.$activeUser.id,
			email: this.$activeUser.email,
			full_name: this.$activeUser.firstName + ' ' + this.$activeUser.lastName,
			role: this.getRoleFromId(this.$activeUser.role.roleId).name
		};

		const accountData = {
			id: this.$activeUser.id,
			name: this.$activeUser.firstName + ' ' + this.$activeUser.lastName,
			is_paying: this.subscription.isPaid,
			planLevel: this.getRoleFromId(this.$activeUser.role.roleId).name,
		};

		try {
			let metrics = await fetchUserMetrics();
			let invoice = await fetchLastInvoice();
			const pendoData = {
				visitor: {
					...visitorData,
					...metrics.metric
				},
				account: {
					...accountData,
					planPrice: invoice ? this.formatInvoice(invoice.amount_due) : null
				}
			}
			pendoData.account.creationDate = metrics.metric.creationDate
			window.pendo.initialize(pendoData);
		} catch(error) {
			console.log('metrics error');
		}
	},
	async upgrade() {
      const store = this.$store;
      store.commit('onboarding/setIsUpgrading', true);
      const path = store.getters['onboarding/currentPath'];
      await this.$router.push({ name: path.steps[0].routeName });
    },
    /**
     * @returns {Promise<void>}
     */
    async getSubscriptionLevels() {
      await this.$store.dispatch('subscriptions/getLevels');
    },
    /**
     * @returns {void}
     */
    onGetHiredButtonClick() {
      this.upgradeRoute = null;
      this.showUpgradeModal = true;
    },
    /**
     * @param {import('vue-router').Route} to
     * @param {import('vue-router').Route} from
     * @param {import('vue-router').NavigationGuardNext} next
     * @returns {void}
     */
    onNavigate(to, from, next) {
      if (to.name === 'dashboard') {
        this.isNavigatingToOnboarding = false;
      } else {
        this.isNavigatingToOnboarding = to.matched.some(({ path }) => path === '/onboarding');
        this.showUpgradeModal = false;
      }
      return next();
    },
    /**
     * @returns {void}
     */
    onSaveSubscription() {
      const { upgradeRoute } = this;
      if (upgradeRoute) {
        this.$router.push(upgradeRoute);
      }
    },
    /**
     * @param {import('vue-router').Route} route
     * @returns {Promise<boolean>}
     */
    async validateRoute(route) {
      if (!this.$isLoggedIn) {
        return true;
      }
      /** @type {SubscriptionLevel | null} */
      const level = await this.$store.dispatch('subscriptions/getMySubscriptionLevel');
      let needsUpgrade = false;
      switch (route.name) {
        case 'availability':
          needsUpgrade = !level?.canUseAvailability;
          break;
      }
      if (needsUpgrade) {
        this.upgradeRoute = route;
        this.showUpgradeModal = true;
        return false;
      }
      return true;
    },
  },
  created() {
	if (this.$activeUer) {
		request({
			url: '/badges/me',
			method: 'get',
		}).then((response) => {
			this.earnedCertifications = [...response.data.earnedCertificationBadges];
		});
	}
  },
  async mounted() {
    const { $isLoggedIn: isLoggedIn, $store: store } = this;
    await Promise.allSettled([
      store.dispatch('subscriptions/getLevels'),
      isLoggedIn && store.dispatch('users/getActiveUser'),
    ]);
    if (isLoggedIn) {
      store.dispatch('chats/startUnreadCountPolling');
		if (process.env.NODE_ENV === "production") {
			this.initPendo();
		}
      if (!(await this.validateRoute(this.$route))) {
        await this.$router.replace({ name: this.$routes.Dashboard.name  });
      }
    }
  },
  beforeDestroy() {
    this.$store.dispatch('chats/stopUnreadCountPolling');
  },
  beforeRouteLeave(to, from, next) {
    return this.onNavigate(to, from, next);
  },
  async beforeRouteUpdate(to, from, next) {
    if (!(await this.validateRoute(to))) {
      /**
       * The destination route requires an account upgrade. The modal has already been shown
       * within the validateRoute() method, so all we need to do here is cancel navigation.
       */
      return next(false);
    }
    return this.onNavigate(to, from, next);
  },
  watch: {
    /**
     * @param {boolean} visible
     * @param {boolean | null | undefined} wasVisible
     * @returns {void}
     */
    showUpgradeModal(visible, wasVisible) {
      if (!visible && wasVisible && !this.isNavigatingToOnboarding) {
        this.upgradeRoute = null;
      }
    },
	$route() {
		this.showMobileNav = false;
		this.showNotificationsDroplist = false;
		this.showCreateDroplist = false;
		this.showAccountDroplist = false;
	},
  },
};
</script>
